import { CompoundLocation } from '../../compoundManagement.types';
import { FunctionComponent } from 'react';
import { DepartureCompletedForm } from '../../shared/sidebar/DepartureCompletedForm';

export type UnannouncedDepartureDetailsProps = {
    compoundVehicleId: string;
    compoundLocation: CompoundLocation;
};

export const UnannouncedDepartureDetails: FunctionComponent<UnannouncedDepartureDetailsProps> = ({
    compoundVehicleId,
    compoundLocation,
}) => (
    <>
        <DepartureCompletedForm
            key={compoundVehicleId}
            timeZone={compoundLocation.timeZone}
            compoundVehicleId={compoundVehicleId}
            meansOfTransportTypeInputDisabled={false}
            disabled={false}
            departureCompletedAt={undefined}
            transportInformation={undefined}
        />
    </>
);
